import React from "react";
import { withTranslation } from "react-i18next";

import OnboardingLayout, { Icon } from "../OnboardingLayout";

/**
 * Onboarding 01 — lieu d'utilisation. L'utilisateur choisit entre la
 * livraison à domicile et un point de collecte ; le choix conditionne
 * l'écran suivant (adresse ou recherche de point).
 */
class UseWash extends React.Component {
  constructor(props) {
    super(props);
    this.state = { useWash: "home" };
  }

  /** `myLove` marque le passage par l'inscription : il pilote la jauge d'étapes. */
  get onboarding() {
    return this.props.location?.state?.myLove === "Pakistan";
  }

  handleBack = () => {
    if (this.onboarding) {
      this.props.history.push("/personal-details", {
        prevLocation: this.props.history.location.pathname,
      });
      return;
    }

    this.props.history.push("/");
  };

  handleContinue = () => {
    const next =
      this.state.useWash === "home" ? "/delivery-details" : "/connect-point";

    this.props.history.push(next, {
      myLove: this.props.location?.state?.myLove,
    });
  };

  renderMode({ id, icon, title, desc, facts }) {
    const selected = this.state.useWash === id;

    return (
      <button
        type="button"
        key={id}
        role="radio"
        aria-checked={selected}
        className={`wosh-ob__mode${selected ? " wosh-ob__mode--on" : ""}`}
        onClick={() => this.setState({ useWash: id })}
      >
        <span className="wosh-ob__tick">
          <Icon name="check" />
        </span>

        <span className="wosh-ob__badge">
          <Icon name={icon} />
        </span>

        <span>
          <span className="wosh-ob__mode-title">{title}</span>
          <span className="wosh-ob__mode-desc">{desc}</span>
        </span>

        <span className="wosh-ob__rule" />

        <ul className="wosh-ob__facts">
          {facts.map((fact) => (
            <li className="wosh-ob__fact" key={fact}>
              <Icon name="check" />
              {fact}
            </li>
          ))}
        </ul>
      </button>
    );
  }

  render() {
    const { t } = this.props;

    return (
      <OnboardingLayout onBack={this.handleBack}>
        <h1 className="wosh-ob__title wosh-ob__centered">
          {t("Where will you use Wosh?")}
        </h1>
        <p className="wosh-ob__lede wosh-ob__centered">
          {t("You can add more addresses later.")}
        </p>

        <div className="wosh-ob__modes" role="radiogroup">
          {this.renderMode({
            id: "home",
            icon: "home",
            title: t("At home"),
            desc: t("We collect and deliver your laundry at your door."),
            facts: [t("Several slots from Monday to Friday")],
          })}
          {this.renderMode({
            id: "point",
            icon: "business",
            title: t("Collection point"),
            desc: t(
              "Drop off and pick up your laundry at your company, office, coworking space or residence."
            ),
            facts: [t("Partners only")],
          })}
        </div>

        <div className="wosh-ob__cta-wrap" style={{ marginTop: 0 }}>
          <button
            type="button"
            className="wosh-ob__cta"
            onClick={this.handleContinue}
          >
            {t("Continue")}
          </button>
        </div>
      </OnboardingLayout>
    );
  }
}

export default withTranslation()(UseWash);
